// Scripts/Components/navbar.ts
// Mobile menu toggle with smooth animations

document.addEventListener("DOMContentLoaded", () => {
    const mobileMenuButton = document.getElementById("mobileMenuButton");
    const mobileMenu = document.getElementById("mobileMenu");
    const mobileMenuBackdrop = document.getElementById("mobileMenuBackdrop");
    const mobileMenuClose = document.getElementById("mobileMenuClose");

    if (!mobileMenuButton || !mobileMenu) return;

    const hamburgerIcon = mobileMenuButton.querySelector(".hamburger-icon") as SVGElement;
    const closeIcon = mobileMenuButton.querySelector(".close-icon") as SVGElement;

    const closeMenu = () => {
        mobileMenu.classList.remove("active");
        mobileMenuBackdrop?.classList.remove("active");
        hamburgerIcon.classList.remove("hidden");
        closeIcon.classList.add("hidden");
        document.body.style.overflow = "";
    };

    const openMenu = () => {
        mobileMenu.classList.add("active");
        mobileMenuBackdrop?.classList.add("active");
        hamburgerIcon.classList.add("hidden");
        closeIcon.classList.remove("hidden");
        document.body.style.overflow = "hidden";
    };

    // 1. Toggle Mobile Menu
    mobileMenuButton.addEventListener("click", () => {
        const isActive = mobileMenu.classList.contains("active");
        if (isActive) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    // 2. Close on close button click
    mobileMenuClose?.addEventListener("click", closeMenu);

    // 3. Close on backdrop click
    mobileMenuBackdrop?.addEventListener("click", closeMenu);

    // 4. Close on link click
    mobileMenu.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", closeMenu);
    });

    // 3. Logic for Modal Triggers (NOW DYNAMIC)
    // Buscamos cualquier elemento con el atributo data-modal-target
    const modalTriggers = document.querySelectorAll("[data-modal-target]");
    
    modalTriggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
            const modalId = trigger.getAttribute("data-modal-target");
            if (modalId) {
                const modalElement = document.querySelector(`app-modal[modal-id="${modalId}"]`) as any;
                if (modalElement && typeof modalElement.open === "function") {
                    modalElement.open();
                } else {
                    console.warn(`No se encontró un componente <app-modal> con modal-id="${modalId}"`);
                }
            }
        });
    });
});
